import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getDepartment,
  getParticularPage,
  getNext,
  getPrevious,
  createDepartment,
  updateDepartment,
  handleSearch,
  getDepartmentById,
} from "./thunk";

const initialState = {
  departments: [],
  edit: false,
  department: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingDepartment: false,
  loadingNext: false,
  showCreateModal: false,
};

export const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllDepartment: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingDepartment = false;
      state.department = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createDepartment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createDepartment.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createDepartment.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(getDepartmentById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDepartmentById.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = true;
      state.department = action.payload.data;
    });
    builder.addCase(getDepartmentById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
      state.department = null;
    });
    builder.addCase(updateDepartment.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateDepartment.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateDepartment.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getDepartment.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingDepartment = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDepartment.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingDepartment = false;
        state.departments = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDepartment.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingDepartment = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllDepartment } = departmentSlice.actions;

export default departmentSlice.reducer;
